<div class="terms-condition-modal">
  <div class="container relative">
    <div class="absolute pointer modal-close-svg" >
      <svg (click)="hideModal()" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 1.51071L13.4893 0L7.5 5.98929L1.51071 0L0 1.51071L5.98929 7.5L0 13.4893L1.51071 15L7.5 9.01071L13.4893 15L15 13.4893L9.01071 7.5L15 1.51071Z" fill="#999" />
      </svg>
    </div>
    <div class="merchant-name-logo flex align-center mar-bot-20">
        <div class="mer-l"><img class="img-fluid" loading="lazy"
                default="https://images.poshvine.com/b/default-thumbnail-square.jpg"
                [src]="merchant?.attributes?.logo_url">
        </div>
        <div class="mer-title f500 fnt-26">{{merchant?.attributes?.name}}</div>
    </div>
    <div class="heading">
        {{offer?.attributes?.title}}
    </div>

    <div class="tnc" [innerHtml]="offer?.attributes?.terms">
    </div>
  </div>
</div>
